import React from 'react'
import { GrPrevious } from 'react-icons/gr'
export default function PreviousButton (props) {
  return (
    <div className='absolute w-1/3 hover:opacity-100 opacity-0 h-full transition-all z-20 left-0 px-4 justify-start inline-flex items-center group/btn cursor-default'>
      <button
        {...props}
        className='group-hover/btn:translate-x-0 -translate-x-full transition-all duration-700 inline-flex absolute rounded-full p-8 items-center justify-center group/spinner z-0 cursor-pointer'
      >
        <GrPrevious size={'16px'} className='relative z-20' />
        <span className='absolute transition-all duration-500 rounded-full w-[48px] h-[48px] z-10 group-hover/btn:animate-spin-slow border-2 border-dotted border-white group-hover/spinner:border-black'></span>
        <span className='absolute transition-all duration-500 rounded-full group-hover/spinner:w-full group-hover/spinner:h-full w-[32px] h-[32px] z-0 bg-white/50 group-hover/spinner:bg-white'></span>
      </button>
    </div>
  )
}
